import { render } from "./Images.vue?vue&type=template&id=6a0c110c"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Desktop\\Projects\\maytoni\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__